<template>
  <main class="page __no-header" id="updatePassword">
    <div class="wrapper">
      <div class="grid">
        <section>
          <router-link tag="a" :to="{ name: 'home' }">
            <img src="img/logos/logo_full@2x.png" alt="">
          </router-link>
        </section>
        <section class="content">
          <div>
            <span v-if="!reset">
              <h4>Confirme o seu e-mail criando a sua senha.</h4>
              <h5>Use pelo menos 8 caracteres.</h5>
            </span>
            <span v-else>
              <h4>Atualize sua senha</h4>
            </span>
            <form class="grid" @submit.prevent="confirmed && strength > 2  ? updatePassword() : null">
              <vue-password-auto :strengthMessages="strengthMessages" @strength-updated="strength = $event" :strength="3" placeholder="Senha" v-model="password" type="password"  required ></vue-password-auto>
              <vue-password placeholder="Confirme sua senha" v-model="confirmation" type="password" :disableStrength="true" required></vue-password>
              <button type="submit" :class="[{ __confirmed: confirmed && strength > 2 }, '__small']">{{ (confirmed && strength > 2) ? 'Atualizar' : 'Invalido' }}</button>
            </form>
            <div v-if="strength > 0" :class="['strength', `__${strength}`]">
              {{ strengthMessages[strength] }}
            </div>
          </div>
          <footer>
            &copy; 2019 Todos os direitos reservados. RACE é uma marca registrada pelo INPI.
            <nav>
              <ul>
                <router-link tag="li" :to="{ name: 'home' }">INÍCIO</router-link>
                <router-link tag="li" :to="{ name: 'services' }">SERVIÇOS</router-link>
                <router-link tag="li" :to="{ name: 'network' }">REDE</router-link>
                <router-link tag="li" :to="{ name: 'about' }">EMPRESA</router-link>
                <router-link tag="li" :to="{ name: 'contact' }">CONTATO</router-link>
              </ul>
            </nav>
          </footer>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
import { VuePassword, VuePasswordAuto } from 'vue-password'
// Define a senha com o link de uso unico do e-mail (?email=...&token=...&mode=activate|reset).
// activate: primeira senha do cadastro (account/activate); reset: recuperacao (password/reset).
export default{
  name: 'updatePassword',
  data () {
    return {
      email: null,
      password: '',
      token: null,
      confirmation: '',
      strength: 0,
      strengthMessages: ['Senha muito fraca', 'Senha fraca', 'Senha mediana', 'Senha forte', 'Senha muito forte']
    }
  },
  computed: {
    confirmed () {
      return this.confirmation ? (this.password === this.confirmation) : null
    },
    reset () {
      return this.$route.query.reset === 'true' || this.$route.query.reset === true || this.$route.query.mode === 'reset'
    }
  },
  beforeMount () {
    this.email = this.$route.query.email || null
    this.token = this.$route.query.token || null
  },
  methods: {
    updatePassword () {
      if (!this.email || !this.token) {
        this.showError('Link incompleto. Abra o link do e-mail novamente.')
        return
      }
      this.$Progress.start()
      const target = this.reset ? 'password/reset' : 'account/activate'
      this.$http.post(this.$api({ target }), {
        email: this.email,
        token: this.token,
        password: this.password,
        password_confirmation: this.confirmation
      }).then(() => {
        this.$Progress.finish()
        this.$router.push({ name: 'orientations', query: { reset: this.reset } })
      }).catch(err => {
        this.$Progress.fail()
        const data = err.response && err.response.data
        const first = data && data.errors ? Object.values(data.errors)[0][0] : null
        this.showError(first || (data && data.message) || 'Não foi possível atualizar a senha. Tente novamente.')
      })
    },
    showError (message) {
      this.$toasted.show(message, { theme: 'primary', position: 'top-center', duration: 6000, type: 'error' })
    }
  },
  components: {
    VuePassword,
    VuePasswordAuto
  }
}
</script>
